export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7081.22927fa2.jpg";